/**
 * Swym ウィッシュリストをテーマの product-item で描画する。
 * 削除ボタンは従来の Swym スタイルを踏襲し、deleteFromList API を呼ぶ。
 */
(function initSwymWishlistGrid() {
  var root = document.querySelector('[data-swym-wishlist-grid]');
  if (!root) {
    return;
  }

  var grid = root.querySelector('[data-swym-wishlist-items]');
  var emptyEl = root.querySelector('[data-swym-wishlist-empty]');
  var loaderEl = root.querySelector('[data-swym-wishlist-loader]');
  var completed = false;
  var fallbackTimer = null;
  var loadStartedAt = Date.now();
  var MIN_LOADER_MS = 300;

  function setLoading(isLoading) {
    root.classList.toggle('is-swym-loading', isLoading);
    if (loaderEl) {
      loaderEl.hidden = !isLoading;
      loaderEl.setAttribute('aria-hidden', isLoading ? 'false' : 'true');
    }
  }

  function showEmpty() {
    if (grid) {
      grid.innerHTML = '';
      grid.hidden = true;
    }
    if (emptyEl) {
      emptyEl.hidden = false;
    }
    finish();
  }

  function showGrid() {
    if (emptyEl) {
      emptyEl.hidden = true;
    }
    if (grid) {
      grid.hidden = false;
    }
  }

  function finish() {
    if (completed) {
      return;
    }

    var elapsed = Date.now() - loadStartedAt;
    var delay = Math.max(0, MIN_LOADER_MS - elapsed);

    window.setTimeout(function () {
      if (completed) {
        return;
      }
      completed = true;
      if (fallbackTimer) {
        window.clearTimeout(fallbackTimer);
      }
      setLoading(false);
      document.body.classList.add('swym-wishlist-container-rendered');
      root.classList.add('is-swym-ready');
    }, delay);
  }

  function getHandleFromUrl(url) {
    if (!url) {
      return '';
    }
    try {
      var path = new URL(url, window.location.origin).pathname;
      var match = path.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (e) {
      return '';
    }
  }

  function fetchProductCardHtml(handle, variantId) {
    var url = '/products/' + encodeURIComponent(handle) + '?view=wishlist-card';
    if (variantId) {
      url += '&variant=' + encodeURIComponent(variantId);
    }
    return fetch(url, {
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Failed to load product card: ' + handle);
      }
      return response.text();
    }).then(function (html) {
      var match = html.match(/<product-item[\s\S]*?<\/product-item>/i);
      if (!match) {
        throw new Error('product-item not found for: ' + handle);
      }
      var template = document.createElement('template');
      template.innerHTML = match[0].trim();
      var item = template.content.querySelector('product-item');
      if (!item) {
        throw new Error('product-item parse failed for: ' + handle);
      }
      return item;
    });
  }

  function createRemoveButton(item, lid, swat) {
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'swym-storefront-layout-grid-item-option-button swym-wishlist-remove-btn';
    button.setAttribute('aria-label', 'ウィッシュリストから削除');
    button.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (button.disabled) {
        return;
      }
      button.disabled = true;
      button.classList.add('is-loading');

      var product = {
        epi: item.epi,
        empi: item.empi,
        du: item.du
      };

      var onSuccess = function () {
        var card = button.closest('[data-swym-wishlist-card]');
        if (card) {
          card.remove();
        }
        if (grid && !grid.querySelector('[data-swym-wishlist-card]')) {
          showEmpty();
        }
      };

      var onError = function () {
        button.disabled = false;
        button.classList.remove('is-loading');
        if (swat && swat.ui && typeof swat.ui.showErrorNotification === 'function') {
          swat.ui.showErrorNotification({ message: '削除に失敗しました' });
        }
      };

      swat.deleteFromList(lid, product, onSuccess, onError);
    });
    return button;
  }

  function createCard(item, lid, swat, productItemEl, index) {
    productItemEl.classList.add('swym-wishlist-card');
    productItemEl.setAttribute('data-swym-wishlist-card', '');
    productItemEl.setAttribute('data-empi', String(item.empi || ''));
    productItemEl.setAttribute('data-epi', String(item.epi || ''));
    productItemEl.style.setProperty('--swym-item-delay', index * 0.06 + 's');
    productItemEl.prepend(createRemoveButton(item, lid, swat));
    return productItemEl;
  }

  function renderItems(items, lid, swat) {
    if (!items || !items.length) {
      showEmpty();
      return;
    }

    showGrid();
    grid.innerHTML = '';

    var tasks = items.map(function (item, index) {
      var handle = getHandleFromUrl(item.du);
      if (!handle) {
        return Promise.resolve(null);
      }
      return fetchProductCardHtml(handle, item.epi)
        .then(function (productItemEl) {
          return createCard(item, lid, swat, productItemEl, index);
        })
        .catch(function () {
          return null;
        });
    });

    Promise.all(tasks).then(function (cards) {
      var rendered = 0;
      cards.forEach(function (card) {
        if (card) {
          grid.appendChild(card);
          rendered += 1;
        }
      });

      if (!rendered) {
        showEmpty();
        return;
      }

      finish();
    });
  }

  function normalizeItems(payload) {
    if (Array.isArray(payload)) {
      return payload;
    }
    if (payload && Array.isArray(payload.items)) {
      return payload.items;
    }
    if (payload && Array.isArray(payload.listcontents)) {
      return payload.listcontents;
    }
    return [];
  }

  function pickWishlist(lists) {
    if (!lists || !lists.length) {
      return null;
    }
    for (var i = 0; i < lists.length; i++) {
      var list = lists[i];
      if (!list.lty || list.lty === 'wl') {
        return list;
      }
    }
    return lists[0];
  }

  function loadWishlist(swat) {
    setLoading(true);
    document.body.classList.remove('swym-wishlist-container-rendered');

    swat.fetchLists({
      callbackFn: function (lists) {
        var wishlist = pickWishlist(lists);
        if (!wishlist || !wishlist.lid) {
          showEmpty();
          return;
        }

        var lid = wishlist.lid;

        if (typeof swat.fetchListCtx === 'function') {
          swat.fetchListCtx(
            { lid: lid },
            function (payload) {
              renderItems(normalizeItems(payload), lid, swat);
            },
            function () {
              renderItems(normalizeItems(wishlist.listcontents), lid, swat);
            }
          );
          return;
        }

        renderItems(normalizeItems(wishlist.listcontents), lid, swat);
      },
      errorFn: function () {
        showEmpty();
      }
    });
  }

  var started = false;

  function onSwymReady(swat) {
    if (started || !swat) {
      return;
    }
    started = true;
    loadWishlist(swat);
  }

  setLoading(true);
  fallbackTimer = window.setTimeout(function () {
    if (!completed) {
      showEmpty();
    }
  }, 15000);

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(onSwymReady);

  if (window._swat) {
    onSwymReady(window._swat);
  }
})();
